<template>
  <div :style="{ color: this.value < 0 ? 'red' : 'green' }">
    {{ Math.max(0, this.value) }}
  </div>
</template>

<script>
export default {
  name: "DaysLeftCell",
  props: ["value", "row", "column"],
};
</script>
